module.exports = __webpack_public_path__ + "static/pic07-c22716740fb947a24e4010a122558351.jpg";